var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","color":"grey","disabled":_vm.disabledButton}},[_c('vue-json-to-csv',{attrs:{"json-data":_vm.itemCSV,"csv-title":_vm.nameCSV}},[_vm._v(" Georeferencia "),_c('v-icon',{staticClass:"ml-2",attrs:{"color":"green","small":""}},[_vm._v(" mdi mdi-file-download ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }